import loanApi from '@/api/now/loanApi'

import StatusService from '@/service/status/StatusService'
import CreditEvaluationsService from '@/service/creditEvaluations/CreditEvaluationsService'

import store from '@/store'

import { sleep } from '@/util'

// import moment from 'moment'

const INTEVAL_MULTIPLICATION = 1.2
const START_POLLING_TIME = new Date()
const MAX_POLLING_TIME = 5 * 60 * 1000

const MINIMUM_POSSIBLE_AMOUNT = 100000
const MINIMUM_REST_INVEST_AMOUNT = 5000

const statusesCardsales = StatusService.statusesSet.statusesCardsales
const statusesNotLoan = StatusService.statusesSet.statusesNotLoan

const swal = (_html, _icon, _confirmButtonText) => {
  return new Promise((resolve, reject) => {
    resolve(window.$swal.fire({
      html: _html,
      icon: _icon,
      confirmButtonText: _confirmButtonText
    }))
  })
}

let loanService = {
  MINIMUM_POSSIBLE_AMOUNT,
  MINIMUM_REST_INVEST_AMOUNT,
  checkStatusBeforeEnter(statuses) {
    let status = store.getters['status/getStatus']
    return statuses.includes(status.code)
  },
  async pollOffer() {
    if (this.checkStatusBeforeEnter(statusesCardsales)) {
      return
    }

    store.dispatch('loading/setIsLoading', true)
    let offer = await this.getCurrentOffer()
    let user = store.getters['auth/getProfile']
    store.dispatch('status/setStatusInProgress', { user: user, offer: offer })
    if (offer.status !== 'in_progress') {
      if (!user.store.business_license_number) {
        store.dispatch('loading/setIsLoading', false)
        return
      }

      await this.getLoanOngoingLeftAmount()
      await this.getCurrentLoan()

      store.dispatch('loading/setIsLoading', false)
      return
    }

    let pollingInterval = 0.5 * 60 * 1000
    await sleep(pollingInterval)

    pollingInterval *= INTEVAL_MULTIPLICATION
    let durationTime = new Date() - START_POLLING_TIME
    if (durationTime < MAX_POLLING_TIME) {
      this.pollOffer()
    }
  },
  getLoanOngoing() {
    return new Promise(async (resolve, reject) => {
      try {
        console.log('getLoanOngoing()')
        let { data } = await loanApi.getLoans({ ongoing: true })
        resolve(data && data[0])
      } catch (e) {
        reject(e)
      }
    })
  },
  getLoanOngoingForRepayment() {
    return new Promise(async (resolve, reject) => {
      try {
        console.log('getLoanOngoingForRepayment()')
        let { data } = await loanApi.getLoans({ ongoing: true })
        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },
  async getLoanOngoingLeftAmount() {
    let { data } = await loanApi.getLoans({ ongoing: true })
    store.dispatch('loan/setLoansRepayment', data)

    let leftAmount = data.filter((loan) => loan.status === 'executed' && loan.type === 'normal').reduce(
      (accumulator, loan) => accumulator + loan.left_amount, 0
    )
    store.dispatch('loan/setLeftAmount', leftAmount)
    console.log('leftAmount', leftAmount)
    let leftMarketingAmount = data.filter((loan) => loan.status === 'executed' && loan.type === 'marketing').reduce(
      (accumulator, loan) => accumulator + loan.left_amount, 0
    )
    store.dispatch('loan/setLeftMarketingAmount', leftMarketingAmount)
    console.log('leftMarketingAmount', leftMarketingAmount)
    store.dispatch('loading/setIsLoading', false)
  },
  getCurrentOffer() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await loanApi.getCurrentOffer()
        store.dispatch('loan/setOffer', data)
        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },
  getCurrentTempOffer() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await loanApi.getCurrentTempOffer()
        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },
  async getCurrentLoan() {
    if (this.checkStatusBeforeEnter(statusesNotLoan)) {
      return
    }

    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await loanApi.getCurrentLoan()
        store.dispatch('loan/setLoanData', data)
        resolve(data)
      } catch (e) {
        reject(e)
      }
    }).catch(error => {
      if (error && error.status && error.status !== 404) {
        throw error
      }
    })
  },
  getLoanWaitingNumber() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await loanApi.getLoanWaitingNumber()
        resolve(data.waitingNumber)
      } catch (e) {
        reject(e)
      }
    })
  },
  getLoanInvestingAmount() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await loanApi.getInvestingAmount()
        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },
  getClosedStoreStatus() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await loanApi.getClosedStore()
        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },
  closeFunding() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await loanApi.closeFunding()
        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },
  getLoanAvailableTime() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await loanApi.getLoanAvailableTime()
        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },
  isLoanAvailableTemporarily() {
    let user = store.getters['auth/getProfile']
    return user.is_loan_available_temporarily
  },
  isLoanAvailable() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await loanApi.getLoanAvailableTime()

        // 1시간 임시 연장
        // if (moment().isBetween(moment('2021-09-23 10:00:00'), moment('2021-09-23 17:00:00'))) {
        //   data.can_loan = true
        // }

        if (this.isLoanAvailableTemporarily()) {
          data.can_loan = true
        }

        // 주말 대출 신청 오픈
        // 주말 대출 신청 제한 코드
        // const dayOfWeek = moment().day()
        // // https://momentjs.com/docs/#/get-set/day/
        // // 0 일요일 / 6 토요일
        // if ([0, 6].some(weekendCode => dayOfWeek === weekendCode)) {
        //   console.log('weekend')
        //   data.can_loan = false
        // }

        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },
  canLoan() {
    let status = store.getters['status/getStatus']
    if (['invested', 'reexecutable'].includes(status.code)) {
      return true
    } else {
      return false
    }
  },
  async postLoan(offerId) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await loanApi.postLoan(offerId)
        resolve(res)
      } catch (e) {
        reject(e)
      }
    }).catch(e => {
      throw e
    })
  },
  async registerFunding() {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await loanApi.registerFunding()
        resolve(res)
      } catch (e) {
        reject(e)
      }
    }).catch(e => {
      throw e
    })
  },
  async executeFunding() {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await loanApi.executeFunding()
        resolve(res)
      } catch (e) {
        reject(e)
      }
    }).catch(e => {
      throw e
    })
  },
  isLoanContractDisable() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await loanApi.getLoanContractAvailableTime()
        resolve(!data.can_contract)
      } catch (e) {
        reject(e)
      }
    })
  },
  async applyLoan(possibleAmount) {
    let isLoanAvailable = await this.isLoanAvailable()
    if (!isLoanAvailable.can_loan) {
      await swal(isLoanAvailable.message_html, 'warning', '확인')
      return
    }

    let offer = store.getters['loan/getOffer']
    if (!offer) {
      await swal('오늘 한도가 생성되지 않았습니다.<br> 고객센터에 문의하세요', 'warning', '확인')
      return
    }

    let leftAmount = store.getters['loan/getLeftAmount']
    if (offer.amount < leftAmount) {
      await swal('한도가 대출 잔액 이상부터<br> 비상금 신청이 가능합니다', 'warning', '확인')
      return
    }

    const user = store.getters['auth/getProfile']
    if (!user.documents.truth_or_falsehood_of_certificate_of_income_amount) {
      await swal('소득금액증명원 확인이 완료되어야<br> 비상금 신청이 가능합니다 ', 'warning', '확인')
      return
    }

    if (!user.kyc.id_card_verification_is_done || !user.kyc.id_card_image_verified) {
      await swal('본인확인 절차가 완료되어야<br> 비상금 신청이 가능합니다', 'warning', '확인')
      return
    }

    let isEvaluationExpired = await CreditEvaluationsService.getIsEvaluationExpired()
    let isCreditEvaluated = await CreditEvaluationsService.getIsCreditEvaluated()
    if (isEvaluationExpired || !isCreditEvaluated) {
      let user = store.getters['auth/getProfile']
      let alert = await swal(
        `${user.name} 사장님.<br><br>신용 인증 유효기간이 만료되어,<br> 신용 인증 페이지로 이동합니다`,
        'warning',
        '인증하러 가기'
      )
      if (alert.isConfirmed) {
        try {
          let { data } = await CreditEvaluationsService.postCreditEvaluations()
          store.dispatch('loading/setIsLoading', true)
          let returnUrl =
            location.origin + '/factoring/evaluation?evid=' + data.uuid
          let url = data.kcb_url + '&RTN_URL=' + encodeURI(returnUrl)
          if (navigator.userAgent.match(/Android/i)) {
            document.location.replace(url)
          } else {
            location.href = url
          }
        } catch (e) {
          console.error(e)
        }
      }
    } else {
      await swal('지금은 대출 신청이 불가능 합니다.', 'warning', '확인')
      // await this.postLoan(offer.uuid)
      // await this.registerFunding()
      // await StatusService.syncStatus()
    }
  },
  async evaluation(param = {}) {
    const user = store.getters['auth/getProfile']
    if (param?.ignoreCertificate !== true && !user.documents.truth_or_falsehood_of_certificate_of_income_amount) {
      await swal('소득금액증명원 확인이 완료되어야<br> 비상금 신청이 가능합니다 ', 'warning', '확인')
      return
    }

    if (!user.kyc.id_card_verification_is_done || !user.kyc.id_card_image_verified) {
      await swal('본인확인 절차가 완료되어야<br> 비상금 신청이 가능합니다', 'warning', '확인')
      return
    }

    let isEvaluationExpired = await CreditEvaluationsService.getIsEvaluationExpired()
    let isCreditEvaluated = await CreditEvaluationsService.getIsCreditEvaluated()
    if (isEvaluationExpired || !isCreditEvaluated) {
      let user = store.getters['auth/getProfile']
      let alert = await swal(
        `${user.name} 사장님.<br><br>신용 인증 유효기간이 만료되어,<br> 신용 인증 페이지로 이동합니다`,
        'warning',
        '인증하러 가기'
      )
      if (alert.isConfirmed) {
        try {
          let { data } = await CreditEvaluationsService.postCreditEvaluations()
          store.dispatch('loading/setIsLoading', true)
          let returnUrl =
            location.origin + '/factoring/evaluation?evid=' + data.uuid
          let url = data.kcb_url + '&RTN_URL=' + encodeURI(returnUrl)
          if (navigator.userAgent.match(/Android/i)) {
            document.location.replace(url)
          } else {
            location.href = url
          }
        } catch (e) {
          console.error(e)
        }
      }
      return false
    }
    return true
  }
}
export default loanService
